/**
 * shortcutsPref.ts — the single-key shortcuts switch (Log Activity slice C2,
 * RULED 2026-10-09, Q1/Q2): WCAG 2.1.4's "mechanism to turn it off", kept
 * DEVICE-LOCAL in browser storage through draftStorage's guard, keyed per
 * tenant and user the way the sheet's last-type key is. Default ON. With no
 * /v1/me identity yet the key is null: ON, and nothing is written. Storage
 * that throws or holds anything but `false` reads as ON.
 */
import { readDraft, writeDraft } from './draftStorage'

export function shortcutsPrefKey(identity: { tenantId: string; subject: string } | null): string | null {
  return identity ? `gss.pref.singleKeyShortcuts.${identity.tenantId}.${identity.subject}` : null
}

export function readShortcutsEnabled(key: string | null): boolean {
  if (!key) return true
  return readDraft<unknown>(key) !== false
}

export function writeShortcutsEnabled(key: string | null, enabled: boolean): void {
  if (key) writeDraft(key, enabled)
}
